module.exports = __webpack_public_path__ + "img/Twitter.9ae5cb0c.png";